import React, { useState, useEffect } from "react";
import { useGlobal } from "reactn";
import { useLocation, useHistory, Link } from "react-router-dom";

import ReactPlayer from "react-player";
import Expand from "react-expand-animated";

import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { useJSONFetcher } from "@outplayed/json-fetcher";
import { useUserPremiumState } from "lib/hooks/userHooks";

const features = [
  {
    title: "Unlock every champion combo with U.GG Boost",
    desc: "We break down the mechanics for every level from basic trading to highlight reels.",
  },
  {
    title: "Input Timing Visualization",
    desc: "Toggle between full and half speed to learn at your own pace.",
  },
  {
    title: "Become a Combo Scholar",
    desc: "Each combo comes with tips on how it works and when to use it.",
  },
];

const PremiumSoon = (props) => {
  const { getChampionIdByName, getChampionName } = getRiotAssetsContext();
  const location = useLocation();

  const champ = location.pathname.split("/")[3];
  const key = getChampionIdByName(champ);
  const championName = getChampionName(Number(key));
  return (
    <div className="premium-soon-container">
      <div className="title">{`${championName}'s Combos and more coming soon.`}</div>
      <div className="desc">
        In the mean time, check out some other champions on our
        <Link to="/lol/combo-database" className="combo-link">
          Combo Database.
        </Link>
      </div>
      <img src="https://static.bigbrain.gg/assets/lol/combos/imgs/premium-combo-sample.png" alt="sample" className="sample-img" />
    </div>
  );
};

const Champ = (props) => {
  const { getChampionImg } = getRiotAssetsContext();
  const { data } = props;
  const champImg = getChampionImg(data.key);
  const history = useHistory();

  const goChamp = (e) => {
    history.push(`/lol/champions/${data.id}/combo/1`);
  };

  return (
    <div className="champ" onClick={goChamp}>
      <img className="champ-img" src={champImg} alt="champ-img" />
      <div className="name">{data.name}</div>
    </div>
  );
};

const FreeSoon = (props) => {
  const { getChampionIdByName, getChampionName } = getRiotAssetsContext();
  const { data: combos, loading: isLoading } = useJSONFetcher(
    `https://static.bigbrain.gg/assets/lol/combos/${process.env.COMBOS_FILENAME}.json`,
  );
  const [display, setDisplay] = useState("block");
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const toggle = (e) => {
    setOpen(!open);
    setDisplay("none");
  };

  if (combos && !isLoading) {
    const champ = location.pathname.split("/")[3];
    const key = getChampionIdByName(champ);
    const championName = getChampionName(Number(key));
    return (
      <div className="free-soon-container">
        <div className="title">{championName} Combos Coming Soon</div>
        <div className="desc">for our Premium users. Sign up and boost yourself today.</div>
        <Link to={{ pathname: "/", state: { scrollToPlans: true } }} className="btn-light-blue">
          Get BOOST
        </Link>
        <div className="desc1">
          Or check out our
          <Link to="/lol/combo-database" className="more-link">
            combo database
          </Link>
        </div>
        <div className="feature-container">
          <div className="features-desc">
            <div className="title">
              RUNES, BUILDS, AND <span className="orange">NOW COMBOS.</span>
            </div>
            <div className="divider"></div>
            <div className="feature-list">
              {features.map((f, index) => {
                return (
                  <div className="feature" key={index}>
                    <div className="title">{f.title}</div>
                    <div className="desc">{f.desc}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="right-side">
            <div className="player-container">
              <ReactPlayer
                url="https://player.vimeo.com/video/389809458"
                playing={true}
                loop={true}
                controls={true}
                light="https://i.vimeocdn.com/video/853615055_600x338.jpg"
                playbackRate={1.0}
                width="100%"
                height="100%"
              />
            </div>
            <div className="big-bar"></div>
            <div className="small-bar"></div>
          </div>
        </div>
        <div className="combo-champs-container">
          <div className="title">Get one free video for each of these available champions.</div>
          <div className="champ-list">
            <div className="champ-container">
              {Object.keys(combos).map((champ, index) => {
                if (index <= 9) {
                  return <Champ data={combos[champ]} key={index} />;
                }
              })}
            </div>
            <Expand className="champ-container-expand" open={open}>
              {Object.keys(combos).map((champ, index) => {
                if (index > 9) {
                  return <Champ data={combos[champ]} key={index} />;
                }
              })}
            </Expand>
            <div className="more-link" style={{ display: `${display}` }} onClick={toggle}>
              and more
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div className="spinthatshit-loader"></div>;
  }
};

const ComboSoon = (props) => {
  const [loggingIn] = useGlobal("loggingIn");
  const { isPremium } = useUserPremiumState();
  if (!loggingIn) {
    return <div className="combo-soon-container">{isPremium ? <PremiumSoon /> : <FreeSoon />}</div>;
  } else {
    return null;
  }
};

export default ComboSoon;
